module.exports = __webpack_public_path__ + "static/img/zupubao.7741be4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mine/zupubao.png
// module id = kiFm
// module chunks = 1